module.exports = "https://static.wmbcdn.com/uniweb/images/bdd9c605273f2952f4b3c408cb825584.svg";